import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import _ from 'lodash';
import { Button } from 'react-bootstrap';

import FormattedMessage from '../../../components/FormattedMessage';
import Loading from '../../../components/Loading/Loading';
import Switch from '../../../components/Switch/Switch';

import { getPlans, updateStepData, error } from '../SubscribeActions';

import { PAGES, trackPageView } from '../../../util/mixpanel';
import { getLocalePrice } from '../../../util/billingUtils';

import '../Subscribe.scss';

export class Plans extends Component {
  static defaultProps = {
    model: {},
    onNext: function() {}
  };

  constructor(props) {
    super(props);
    this.state = {
      planId: '',
      isAnnual: false,
      annualSubscription: true
    };

    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.selectPlan = this.selectPlan.bind(this);
  }

  componentDidMount() {
    this.props.getPlans();

    if (this.props.model.planId) {
      this.setState({
        planId: this.props.model.planId,
        annualSubscription: this.props.model.planId.indexOf('annual') > -1,
        isAnnual: this.props.model.currentPlan && this.props.model.currentPlan.indexOf('annual') > -1
      });
    } else if (!this.props.isUpgrade && this.props.plans.monthly) {
      this.selectRecommendedPlan();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(prevProps.plans, this.props.plans) ||
      prevProps.dashboards != this.props.dashboards ||
      prevState.annualSubscription != this.state.annualSubscription
    ) {
      this.selectRecommendedPlan();
    }

    if (prevProps.model.planId != this.props.model.planId && !!this.props.model.planId) {
      this.setState({
        planId: this.props.model.planId,
        annualSubscription: this.props.model.planId.indexOf('annual') > -1,
        isAnnual: this.props.model.currentPlan && this.props.model.currentPlan.indexOf('annual') > -1
      });
    }
  }

  selectRecommendedPlan() {
    const plans = this.state.annualSubscription ? this.props.plans.annual : this.props.plans.monthly;
    const selected = _.find(plans, p => {
      if (this.props.model.allowed) {
        return p.allowed == this.props.model.allowed;
      } else {
        return p.allowed >= this.props.dashboards;
      }
    });

    if (selected) {
      this.selectPlan(selected);
    }
  }

  handleSwitch() {
    this.setState({ annualSubscription: !this.state.annualSubscription });
  }

  handleNext() {
    if (this.props.model.currentPlan === this.props.model.planId) {
      return false;
    }

    this.props.onNext(this.props.model.allowed < this.props.dashboards ? 2 : 3);
  }

  selectPlan(plan) {
    const model = {
      ...this.props.model,
      planId: plan.id,
      planName: plan.name,
      planType: plan.periodUnit,
      allowed: plan.allowed
    };
    this.props.updateStepData(model);
  }

  trackContactUsOpenEvent() {
    trackPageView(PAGES.CONTACT_US);
  }

  render() {
    const { app, plans, isUpgrade, allowedDashboards, model } = this.props;
    const { planId, isAnnual } = this.state;

    if (!plans.monthly) {
      return <Loading />;
    }

    const renderPlan = (p, isAnnual) => {
      return (
        <div key={p.id} className={`${planId == p.id ? 'active' : ''} ${p.id === model.currentPlan ? 'current' : ''}`}>
          <div className='plan-name'>
            <div className='plan-image'>
              <div className={`plan-${p.id.replace("premium-", "").replace("-ai", "")}`}></div>
            </div>
            <h3>{p.name}</h3>
          </div>
          <div className='line'></div>
          <div className='plan-boards'>
            {p.allowed}{' '}
            {app !== 'file' ? (
              <FormattedMessage id={`board`} mode="capitalize" plural="true" />
            ) : (
              'boards'
            )}
          </div>
          <div className='line'></div>
          <div className='plan-price'>
            <p className='price'>
              {getLocalePrice(p, isAnnual ? Math.round(p.priceTotal / 12) : p.priceTotal, true)}
              <small> / month</small>
            </p>
            <p>
              {getLocalePrice(p, isAnnual ? p.priceTotal : p.priceTotal * 12, true)}
              <small> / year</small>
            </p>
          </div>
          <div className='line'></div>
          {/*<div className='plan-premium-package'>
            <Switch
              id="premiumPackage"
              className="switch_box_right_label"
              name="premiumPackage"
              label={['Premium Package', <br/> ,'(+$228 / year)']}
            />
          </div>*/}
          {isUpgrade ? (
            <Button
              onClick={() => this.selectPlan(p)}
              className='btn-select'
              disabled={p.id === model.currentPlan}
            >
              {p.id === model.currentPlan ? 'Current plan' : p.allowed < allowedDashboards ? 'Downgrade' : 'Upgrade'}
            </Button>
          ) : (
            <Button onClick={() => this.selectPlan(p)} 
                    className='btn-select'>
              {planId == p.id ? 'Selected' : 'Select'} plan
            </Button>
          )}
        </div>
      );
    };

    return (
      <div className='subscribe_inner_content'>
        <div className='subscribe_plan'>
          {!isUpgrade || (isUpgrade && !isAnnual) ? (
            <div className='chose_subscription'>
              <p className={`subscription ${!this.state.annualSubscription ? 'active' : ''}`}>
                Monthly <span>subscription</span>
              </p>
              <Switch
                id="type-selector"
                name="type-selector"
                throttleInterval={0}
                checked={this.state.annualSubscription}
                onChange={this.handleSwitch}
              />
              <p className={`subscription ${this.state.annualSubscription ? 'active' : ''}`}>
                Annual <span>subscription</span>
              </p>
            </div>
          ) : (
            <div className='chose_subscription'>
              <p className='subscription'>&nbsp;</p>
            </div>
          )}
          {!this.state.annualSubscription ? (
            <div className='plans-list'>{plans.monthly.map(p => renderPlan(p))}</div>
          ) : (
            <div className='plans-list'>{plans.annual.map(p => renderPlan(p, true))}</div>
          )}
        </div>

        
        <div className='action_box_billing'>
          {!this.props.expired ? (
            <Button variant='secondary' className='btn_prev' onClick={this.props.router.goBack}>
              Back
            </Button>
          ) : (
            <div></div>
          )}
          <p className='node'>
            Need more than 10 <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" plural="true" />?{' '}
            <a href="https://getnave.com/contact" 
              onClick={this.trackContactUsOpenEvent}
              onAuxClick={this.trackContactUsOpenEvent}
              target="_blank">
              Get in touch
            </a>{' '}
            for a custom quote!
          </p>
          <Button variant='primary' className='btn_next' onClick={this.handleNext}>
            Next
          </Button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPlans: () => dispatch(getPlans()),
    updateStepData: model => dispatch(updateStepData(model)),
    setError: err => dispatch(error(err, { log: false }))
  };
};

const mapStateToProps = state => {
  const dashboards = state.dashboards.loaded ? state.dashboards.list.length : state.auth.user.dashboards || 0;

  return {
    app: state.app.app,
    plans: state.subscription.plans,
    model: state.subscription.model,
    allowedDashboards: state.auth.user.allowedDashboards,
    expired: state.auth.user.expired,
    username: state.auth.user.profile.name,
    email: state.auth.user.email,
    dashboards
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Plans));
